!function (r, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define([], t) : "object" == typeof exports ? exports["jsonapi-normalizer"] = t() : r["jsonapi-normalizer"] = t();
}(this, function () {
  return function (r) {
    function t(e) {
      if (n[e]) return n[e].exports;
      var o = n[e] = {
        exports: {},
        id: e,
        loaded: !1
      };
      return r[e].call(o.exports, o, o.exports, t), o.loaded = !0, o.exports;
    }

    var n = {};
    return t.m = r, t.c = n, t.p = "", t(0);
  }([function (r, t) {
    "use strict";

    function n(r) {
      if (Array.isArray(r)) {
        for (var t = 0, n = Array(r.length); t < r.length; t++) n[t] = r[t];

        return n;
      }

      return Array.from(r);
    }

    function e(r, t) {
      var n = t.type,
          e = t.id;
      r[n] || (r[n] = []), r[n].push(e);
    }

    function o(r, t) {
      var n = t.type,
          e = t.id,
          o = t.attributes;
      return r[n] || (r[n] = {}), r[n][e] = u({
        id: e
      }, o, a(t)), r;
    }

    function a(r) {
      var t = r.relationships;

      if (t) {
        var n = {};
        return Object.keys(t).map(function (r) {
          n[r] = i(t[r].data);
        }), n;
      }
    }

    function i(r) {
      return Array.isArray(r) ? [].concat(n(r)) : u({}, r);
    }

    var u = Object.assign || function (r) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];

        for (var e in n) Object.prototype.hasOwnProperty.call(n, e) && (r[e] = n[e]);
      }

      return r;
    };

    r.exports = function (r) {
      var t;
      t = Array.isArray(r.data) ? r.data : [r.data];
      var a = r.included || [],
          i = [].concat(n(t), n(a)),
          u = {},
          c = {};
      return i.forEach(function (r) {
        e(u, r), o(c, r);
      }), {
        result: u,
        entities: c
      };
    };
  }]);
});